import { Injectable, inject } from '@angular/core';
import { HttpBackend, HttpClient, HttpContext } from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {Session} from 'src/app/model/event/session.model';
import {Event} from 'src/app/model/event/event.model';
import {SexeEnum} from 'src/app/model/enums/sexe.enum';
import {InfoRegisterEventDTO} from 'src/app/model/dto/info-register-event.dto';
import {Webservice} from './webservice';

@Injectable({
    providedIn: 'root'
})
export class EventWebservice extends Webservice {
  protected readonly httpBackend = inject(HttpBackend);
  private readonly httpBypass = new HttpClient(this.httpBackend);

    constructor() {
        super();
        this.entity = 'events';
    }

    getEventTypes(age: Date, sex: SexeEnum, idPlace: number, idUser: number): Observable<Event[]> { // Liste tous les types d'evenements
        const info = new InfoRegisterEventDTO();
        info.sex = sex;
        info.age = age;
        info.idPlace = idPlace;
        info.idUser = idUser;

        return this.httpBypass.post(`${this.root}/inscription`, info).pipe(
            map(value => value as Event[])
        );
    }

    getEventAge(idEvent: number): Observable<{
        session: Session
    }> {
        return this.http.get<{
            session: Session
        }>(`${this.root}/registered/${idEvent}/age`);
    }
}
